import Api from '../api'
import styles from '../../css/game-info-card-v2.pcss.json'
import { SGPlugin } from '../common/SGPlugins'
import { captureFetchException } from '../common/helpers'
import { showToast } from '../components/toast'

declare global {
  interface HTMLButtonElement {
    prevClasses: string
  }
}

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLInputElement>) => {
  elements.forEach((element) => {
    const elementType = element.tagName.toLowerCase()
    const eventType = elementType === 'input' ? 'change' : 'click'
    element.addEventListener(eventType, (_event) => {
      if (elementType === 'input' && !element.checked) {
        return
      }
      const options = SGPlugin.getElementOptions(element, 'game-rating', false)
      if (elementType !== 'input') {
        document.querySelectorAll<HTMLInputElement>(`input[data-game-rating-id="${options.id}"]`).forEach(input => {
          input.checked = false
        })
      }

      const buttons = document.querySelectorAll<HTMLButtonElement>(`button[data-game-rating-id="${options.id}"]`)
      buttons.forEach(button => {
        button.prevClasses = button.classList.toString()
        const className = button.getAttribute('data-game-rating-in-class') ?? 'user-rating__clear--in'
        if (parseInt(element.value) > 0) {
          button.classList.add(className)
        } else {
          button.classList.remove(className)
        }
      })

      Api.post<{
        type: 'success' | 'error',
        text: string,
        new_rate: number,
        rate_color: string,
        rate_count_string: string,
        user_rate: number
      }>({
        url: `games/rate`,
        body: {
          game_id: options.id,
          rate: element.value,
        }
      })
        .then(result => {
          if (result.type !== 'success') {
            showToast({
              type: 'error',
              text: result.text,
            })
            return
          }

          let realStyles = styles

          const ratingHolders = document.querySelectorAll(`[data-game-rating-user-total="${options.id}"]`)
          ratingHolders.forEach((holder) => {
            let ratingContainer = holder.querySelector(`.${realStyles['users-rating']}`)
            ratingContainer.classList.remove(realStyles['users-rating--red'])
            ratingContainer.classList.remove(realStyles['users-rating--orange'])
            ratingContainer.classList.remove(realStyles['users-rating--green'])
            ratingContainer.classList.remove(realStyles['users-rating--gray'])
            ratingContainer.classList.add(realStyles[`users-rating--${result.rate_color}`])
            holder.querySelector(`.${realStyles['users-rating__total']}`).innerHTML = `${result.new_rate}`
            holder.querySelector(`.${realStyles['users-rating__count']}`).innerHTML = result.rate_count_string
          })
          showToast({
            type: 'success',
            text: result.text,
          })
        })
        .catch((error) => {
          showToast({
            type: 'error',
            text: 'Произошла ошибка. Попробуй позже.',
          })
          captureFetchException(error)

          buttons.forEach(button => {
            button.className = button.prevClasses
          })
        })
    })
  })
}
